import { useEffect, useState } from "react";
import { lyricScript, LyricScript } from "../../utils/i18n";

/** 가사 표기(한글/로마자/둘 다) — 설정을 바꾸면 바로 다시 그린다 */
export const useLyricScript = (): LyricScript => {
  const [v, setV] = useState<LyricScript>(lyricScript());
  useEffect(() => {
    const on = () => setV(lyricScript());
    window.addEventListener("cs-lyric-script", on);
    return () => window.removeEventListener("cs-lyric-script", on);
  }, []);
  return v;
};
